module.exports = __webpack_public_path__ + "static/media/google-play-badge.c1c3987e.png";